import * as S from '@effect/schema/Schema';
import { Address, Reward } from '@infl-ts/ui-advocate-components';
import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
var Profile = t.type({
  id: t.string,
  currentPoints: t.number,
  shippingAddress: nullable(Address),
  isAdmin: t["boolean"]
});
export var RewardAndProfileQuery = t.type({
  reward: nullable(Reward),
  profile: Profile
});
export var RejectPerkErrors = t.type({
  __typename: t.literal('RejectPerkErrors'),
  errors: t.array(t.type({
    message: t.string
  }))
});
export var RejectPerkResult = t.type({
  __typename: t.literal('RejectPerkResult'),
  message: nullable(t.string)
});
export var RejectPerkOutput = t.type({
  rejectPerk: t.union([RejectPerkErrors, RejectPerkResult])
});
export var RejectPerkInput = t.type({
  input: t.type({
    id: t.string
  })
});
export var RewardDetailsPageBlockConfig = S.struct({
  typename: S.literal('RewardDetailsPageBlock'),
  id: S.string,
  hash: S.string
});